import { render, staticRenderFns } from "./stadium_map2.vue?vue&type=template&id=0ecbf907&"
import script from "./stadium_map2.vue?vue&type=script&lang=ts&"
export * from "./stadium_map2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports